import moment from 'moment-timezone';
import { TimeDifference } from '../models/time-difference';
import { isNullOrUndefined } from './util';

export class TimeUtil {
  /**
   * Converts seconds to minutes with 2 digit precision
   *
   * @param seconds
   */
  static convertSecondsToMinutes(seconds: number): number {
    return parseFloat((seconds / 60).toFixed(2));
  }

  /**
   * Returns a TimeDifference object.
   *
   * @param totalMinutes
   */
  static convertMinutesToTimeDifference(totalMinutes: number): TimeDifference {
    const totalHours = Math.floor(totalMinutes / 60);
    const days = Math.floor(totalHours / 24);
    const hours = totalHours - days * 24;
    const minutes = totalMinutes % 60;
    return new TimeDifference(days, hours, minutes);
  }

  static secondsToDurationString(input: number): string {
    let duration = moment().startOf('day').add('s', input);

    // Round up seconds
    if (duration.seconds()) {
      duration = duration.add(1, 'minutes');
    }

    let durationString = '';
    if (duration.hour() > 0) {
      if (duration.hour() === 1) {
        durationString += 'H [hour] ';
      } else {
        durationString += 'H [hours] ';
      }
    }

    if (duration.minute() > 0) {
      if (duration.minute() === 1) {
        durationString += 'm [minute] ';
      } else {
        durationString += 'm [minutes] ';
      }
    }
    // if (duration.seconds() > 0) {
    //   durationString += ' s [seconds]';
    // }

    return duration.format(durationString);
  }

  static secondsToHoursAndMinutesString(durationSeconds: number) {
    let durationDisplay: string = '';
    const hours: number = Math.floor(durationSeconds / 3600);
    const minutes: number = Math.floor((durationSeconds - hours * 3600) / 60);

    if (hours > 0) {
      if (hours === 1) {
        durationDisplay += hours + ' hr ';
      } else {
        durationDisplay += hours + ' hrs ';
      }
    }
    if (minutes > 0) {
      if (minutes === 1) {
        return (durationDisplay += minutes + ' min');
      } else {
        return (durationDisplay += minutes + ' mins');
      }
    }

    return durationDisplay;
  }

  // TODO: Rename this to buildFullDateFromTimeAndDate
  static setPickupDateHoursAndMinutesFromFormString(pickupDate: string, itineraryDate: Date, timeZone = 'UTC'): Date {
    if (isNullOrUndefined(pickupDate) || pickupDate === '') {
      return null;
    }
    const hours = pickupDate.split(':')[0];
    const minutes = pickupDate.split(':')[1];
    const rideRequestDate = new Date();

    const itineraryMoment = moment(itineraryDate);

    rideRequestDate.setFullYear(itineraryMoment.year(), itineraryMoment.month(), itineraryMoment.date());

    rideRequestDate.setHours(+hours);
    rideRequestDate.setMinutes(+minutes);

    return this.adjustDateToTimeZone(rideRequestDate, timeZone);
  }

  static adjustDateToTimeZone(date: Date, timeZone: string): Date {
    const formattedDateString = moment(date).format('YYYY-MM-DD HH:mm');
    return moment.tz(formattedDateString, timeZone).toDate();
  }

  static convert24HourTimeTo12HourTime(milTime: string): string {
    let time = milTime;
    const splitTime = milTime.split(':');
    if (splitTime && splitTime.length > 2) {
      if (+splitTime[0] > 12) {
        time = `${+splitTime[0] - 12}:${splitTime[1]} PM`;
      } else {
        if (+splitTime[0] === 0) {
          time = `12:${splitTime[1]} AM`;
        } else if (+splitTime[0] === 12) {
          time = `${+splitTime[0]}:${splitTime[1]} PM`;
        } else {
          time = `${+splitTime[0]}:${splitTime[1]} AM`;
        }
      }
    }
    return time;
  }
}
